var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultPageMenu',{attrs:{"name":"construction","routes":Array('construction_main', 'construction_services', 'construction_partners', 'construction_seo')}})}
var staticRenderFns = []

export { render, staticRenderFns }